module.exports = __webpack_public_path__ + "img/P60-zh.ae9135d7.png";